import {
  Field,
  FilterCombobox,
} from '@/features/reports/components/shared/filter-combobox.component';
import { DateRangeFilterField } from '@/shared/ui';
import { X } from 'lucide-react';

interface Option {
  label: string;
  value: string;
}

export interface UsersReportFilterValues {
  status: string;
  groupName: string;
  brokerCode: string;
  advisoryCode: string;
  productCode: string;
  inviteExpired: string;
  invitedFrom: string;
  invitedTo: string;
  lastLoginFrom: string;
  lastLoginTo: string;
}

interface UsersReportFiltersProps {
  /** Painel aberto/fechado (controla a animação de abrir/fechar). */
  open: boolean;
  hasActiveFilter: boolean;
  values: UsersReportFilterValues;
  statusOptions: Option[];
  roleOptions: Option[];
  brokerOptions: Option[];
  advisoryOptions: Option[];
  productOptions: Option[];
  inviteOptions: Option[];
  onChange: (_patch: Partial<UsersReportFilterValues>) => void;
  onClear: () => void;
}

/** Painel recolhível de filtros do relatório de usuários (mesmo padrão da Gestão de Carteira). */
export function UsersReportFilters({
  open,
  hasActiveFilter,
  values,
  statusOptions,
  roleOptions,
  brokerOptions,
  advisoryOptions,
  productOptions,
  inviteOptions,
  onChange,
  onClear,
}: UsersReportFiltersProps) {
  return (
    <div
      className={`grid transition-all duration-300 ease-in-out ${
        open ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
      }`}
    >
      <div className='overflow-hidden'>
        <div className='mt-3 rounded-3xl bg-[#E7E8E9]/50 px-6 py-4'>
          <div className='grid grid-cols-1 gap-4 md:grid-cols-3'>
            <Field label='Status'>
              <FilterCombobox
                placeholder='Selecione o status'
                options={statusOptions}
                value={values.status}
                onChange={status => onChange({ status })}
              />
            </Field>

            <Field label='Perfil'>
              <FilterCombobox
                placeholder='Selecione o perfil'
                options={roleOptions}
                value={values.groupName}
                onChange={groupName => onChange({ groupName })}
              />
            </Field>

            <Field label='Convite'>
              <FilterCombobox
                placeholder='Expirado ou vigente'
                options={inviteOptions}
                value={values.inviteExpired}
                onChange={inviteExpired => onChange({ inviteExpired })}
              />
            </Field>

            <Field label='Assessoria'>
              <FilterCombobox
                placeholder='Selecione a assessoria'
                options={advisoryOptions}
                value={values.advisoryCode}
                onChange={advisoryCode => onChange({ advisoryCode })}
              />
            </Field>

            <Field label='Corretora'>
              <FilterCombobox
                placeholder='Selecione a corretora'
                options={brokerOptions}
                value={values.brokerCode}
                onChange={brokerCode => onChange({ brokerCode })}
              />
            </Field>

            <Field label='Produtos'>
              <FilterCombobox
                placeholder='Selecione o produto'
                options={productOptions}
                value={values.productCode}
                onChange={productCode => onChange({ productCode })}
              />
            </Field>

            <Field label='Envio do convite'>
              <DateRangeFilterField
                fullWidth
                from={values.invitedFrom}
                to={values.invitedTo}
                placeholder='Período de envio'
                onChange={range =>
                  onChange({ invitedFrom: range.from, invitedTo: range.to })
                }
              />
            </Field>

            <Field label='Último login'>
              <DateRangeFilterField
                fullWidth
                from={values.lastLoginFrom}
                to={values.lastLoginTo}
                placeholder='Período do login'
                onChange={range =>
                  onChange({ lastLoginFrom: range.from, lastLoginTo: range.to })
                }
              />
            </Field>
          </div>

          {hasActiveFilter && (
            <button
              type='button'
              onClick={onClear}
              className='mt-3 flex items-center gap-1 py-1 text-sm font-semibold text-alba-blue-500 hover:text-alba-blue-600'
            >
              <X className='h-4 w-4' />
              Limpar Seleção
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
